import type { HeaderItem } from '@/components/headerItems/types';

export function hasVisibleHeaderItems(items: HeaderItem[] | undefined): boolean {
  return Boolean(items?.some((item) => !item.isHidden));
}
